import { render, staticRenderFns } from "./RealtimeTaskTree.vue?vue&type=template&id=79cfebc0&"
import script from "./RealtimeTaskTree.vue?vue&type=script&lang=js&"
export * from "./RealtimeTaskTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports